/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Pose_Gave_Up_TitleInputs */

const en_us2_body_assessment_pose_gave_up_title = /** @type {(inputs: Body_Assessment_Pose_Gave_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The photo wasn't taken`)
};

const pt_br2_body_assessment_pose_gave_up_title = /** @type {(inputs: Body_Assessment_Pose_Gave_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A foto não saiu`)
};

const es_419_body_assessment_pose_gave_up_title = /** @type {(inputs: Body_Assessment_Pose_Gave_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La foto no se tomó`)
};

const pt_pt2_body_assessment_pose_gave_up_title = /** @type {(inputs: Body_Assessment_Pose_Gave_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A foto não foi tirada`)
};

const fr_fr2_body_assessment_pose_gave_up_title = /** @type {(inputs: Body_Assessment_Pose_Gave_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La photo n'a pas été prise`)
};

const de_de2_body_assessment_pose_gave_up_title = /** @type {(inputs: Body_Assessment_Pose_Gave_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Foto wurde nicht gemacht`)
};

const it_it2_body_assessment_pose_gave_up_title = /** @type {(inputs: Body_Assessment_Pose_Gave_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La foto non è stata scattata`)
};

/**
* | output |
* | --- |
* | "The photo wasn't taken" |
*
* @param {Body_Assessment_Pose_Gave_Up_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_pose_gave_up_title = /** @type {((inputs?: Body_Assessment_Pose_Gave_Up_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Pose_Gave_Up_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_pose_gave_up_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_pose_gave_up_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_pose_gave_up_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_pose_gave_up_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_pose_gave_up_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_pose_gave_up_title(inputs)
	return en_us2_body_assessment_pose_gave_up_title(inputs)
});
export { body_assessment_pose_gave_up_title as "body-assessment.pose_gave_up_title" }